import {request} from '@/utils/http';

let goodsList = '/fronted/goods/list';
let goodsDetail = '/fronted/goods/detail'
let goodstree = '/fronted/goods/category/tree'
let hotList = '/fronted/goods/hot'
let goodsKeyword = '/fronted/goods/keyword'
let remandsave = '/fronted/remand/save'
let subscribesave = '/fronted/subscribe/save'
let subscribeReplenish = '/fronted/subscribe/replenish'
let replenishList = '/fronted/subscribe/replenish/record'


export function GET_GOODSLIST(params){
  return request(goodsList,'get',params)
}
export function GET_GOODSTREE(params){
  return request(goodstree,'get',params)
}
export function GET_GOODSDETAIL(params){
  return request(goodsDetail,'get',params)
}
export function GET_HOTLIST(params){
  return request(hotList,'get',params)
}
export function GET_GOODSKEYWORD(params){
  return request(goodsKeyword,'get',params)
}
export function POST_REMANDSAVE(params){
  return request(remandsave,'post',params)
}
export function POST_SUBSCRIBESAVE(params){
  return request(subscribesave,'post',params)
}
export function GET_SUBSCRIBEREPLENISH(params){
  return request(subscribeReplenish,'get',params,{},'','',true)
}
export function GET_REPLENISHLIST(params){
  return request(replenishList,'get',params,{},'','',true)
}


// WEBPACK FOOTER //
// ./src/api/goods.api.js